export default __webpack_public_path__ + "static/chimney-removal-single-689fd0e00f8d4ae8cad3a65fdfac320c.jpg";